/**
 * FAQ-item adapter for CodeStitch FAQ accordions.
 *
 * Recognises `ul.cs-faq-group > li.cs-faq-item` repeat units. FAQ groups are
 * vertical flex columns (`display:flex; flex-direction:column`), so this is the
 * first VERTICAL (`reorderAxis:'y'`) draggable kind — it proves the axis
 * generalization from the Phase 1 contract refactor.
 *
 * Some FAQ sections render TWO side-by-side groups (e.g. stitch-2407's
 * cs-faq-group1 / cs-faq-group2, or tabbed multi-FAQ layouts). Cross-group
 * targeting is prevented for free: the drag engine filters siblings from the
 * dragged item's OWN parent `ul.cs-faq-group`, so a drag in one column can only
 * reorder within that column.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

export const faqItemAdapter = {
  kind: 'faq-item',
  label: 'FAQ item',
  itemSelector: 'li.cs-faq-item',
  parentSelector: 'ul.cs-faq-group',
  reorderSelector: 'ul.cs-faq-group > li.cs-faq-item',
  reorderSiblingSelector: 'ul.cs-faq-group > li.cs-faq-item',
  // Vertical stack — drives clientY hit-testing and translateY shift CSS.
  reorderAxis: 'y',
  historyLabel: 'Reorder FAQ item',
  toastText: 'FAQ item reordered',
  vtPrefix: 'pb-faq-',
  vtSelector: 'ul.cs-faq-group > li.cs-faq-item',
  moveFn: moveSiblingPreservingEids,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    return probe.closest('li.cs-faq-item');
  }
};
